export default __webpack_public_path__ + "static/media/background-color.2f82322e.jpg";